import { CdpaButtonComponent, CdpaButtonId } from "../../common/components/cdpaButton.component";
export class ErrorScreen {
    constructor() {
        if (!document.getElementById(CdpaButtonId.TryAgain)) {
            return;
        }
        const button = new CdpaButtonComponent(CdpaButtonId.TryAgain);
        button.onClick$.subscribe(() => {
            location.reload();
        });
    }
}
